import { CustomParameters } from '@accedo/one-plugin-sdk';

export interface CloseHandler {
  onClose: () => void;
  ignoreDefault?: boolean;
  isCancelOnly?: boolean;
}

export interface ShowPaywallParams {
  overrides?: { token?: string; expiration?: string; isLoggedIn?: boolean };
  closeHandler?: CloseHandler;
  customParameters?: CustomParameters;
  /** Only show products that would give the user entitlements to watch a
   * specific content. Array of the entitlement tags of the content. */
  fetchWithEntitlementTags?: string[];
  /** Exclude products that would only give the user entitlements that they
   * already have. Array of the entitlement tags of the user. */
  filterOutMatchingEntitlements?: string[];
  /** Exclude subscriptions in the given subscription groups. Mainly to
   * filter out subscription groups that the user already owns. */
  filterOutSubscriptionGroupIds?: string[];
  /** Only show products that are part of the specified subscription groups.
   * Array of subscription group IDs. For changing a subscription, it will be
   * the group ID of that. Otherwise, none. Array for future proofing. */
  subscriptionGroups?: string[];
}

export enum CardStatus {
  Valid = 'valid',
  AboutToExpire = 'aboutToExpire',
  Expired = 'expired',
  NotFound = 'notFound',
}

export enum PaymentStore {
  Mpp = 'MPP',
  InPlayer = 'InPlayer',
  Cleeng = 'Cleeng',
  Unknown = 'Unknown',
}

export enum PaymentFormKey {
  CardHolderName = 'cardHolderName',
  CardNumber = 'cardNumber',
  ExpirationDate = 'expirationDate',
  SecurityCode = 'securityCode',
  BillingZipCode = 'billingZipCode',
  Timestamp = 'timestamp',
}
